/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Story_PublishedInputs */

const en_msg_story_published = /** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story published successfully`)
};

const es_msg_story_published = /** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia publicada con éxito`)
};

const fr_msg_story_published = /** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story publiée avec succès`)
};

const de_msg_story_published = /** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story erfolgreich veröffentlicht`)
};

const id_msg_story_published = /** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerita berhasil diterbitkan`)
};

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const ja_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const zh_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const ar_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const it_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const ru_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const pt_msg_story_published = en_msg_story_published;

/** @type {(inputs: Msg_Story_PublishedInputs) => LocalizedString} */
const ko_msg_story_published = en_msg_story_published;

/**
* | output |
* | --- |
* | "Story published successfully" |
*
* @param {Msg_Story_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_story_published = /** @type {((inputs?: Msg_Story_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Story_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_story_published(inputs)
	if (locale === "es") return es_msg_story_published(inputs)
	if (locale === "fr") return fr_msg_story_published(inputs)
	if (locale === "de") return de_msg_story_published(inputs)
	if (locale === "ja") return ja_msg_story_published(inputs)
	if (locale === "zh") return zh_msg_story_published(inputs)
	if (locale === "ar") return ar_msg_story_published(inputs)
	if (locale === "id") return id_msg_story_published(inputs)
	if (locale === "it") return it_msg_story_published(inputs)
	if (locale === "ru") return ru_msg_story_published(inputs)
	if (locale === "pt") return pt_msg_story_published(inputs)
	return ko_msg_story_published(inputs)
});